import React from 'react';
import { Link, useLocation, useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const { lang = 'ar' } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const isHome = /^\/(ar|en)\/?$/.test(location.pathname);

  const goAnchor = (id) => (e) => {
    e.preventDefault();
    if (!isHome) {
      navigate(`/${lang}`);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 80);
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const openCookiePrefs = (e) => {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent('open-cookie-prefs'));
  };

  return (
    <footer style={{ background: 'var(--gd-navy)', color: '#dbe3ef' }}>
      <div className="container-x" style={{ padding: '72px 20px 32px' }}>
        <div className="grid gap-10 lg:gap-14" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))' }}>
          <div style={{ maxWidth: 360 }}>
            <div className="flex items-center gap-3 mb-4">
              <svg width="32" height="32" viewBox="0 0 64 64" aria-hidden="true">
                <rect width="64" height="64" rx="10" fill="#13315c"/>
                <path d="M6 46 L18 30 L26 38 L36 22 L46 34 L58 20 L58 52 L6 52 Z" fill="#c66b3d"/>
                <path d="M6 46 L18 30 L26 38 L36 22 L46 34 L58 20" fill="none" stroke="#f5f5f2" strokeWidth="2" strokeLinejoin="round"/>
              </svg>
              <span className="font-serif" style={{ fontSize: 20, color: 'white', fontWeight: 600 }}>{t('brand.name')}</span>
            </div>
            <p style={{ fontSize: 14, lineHeight: 1.7, color: '#b7c4d8' }}>{t('footer.about')}</p>
          </div>

          <div>
            <h4 style={{ color: 'white', fontSize: 12, letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 16, fontWeight: 700 }}>
              {t('footer.navTitle')}
            </h4>
            <ul className="flex flex-col gap-2.5" style={{ fontSize: 14 }}>
              <li><a href="#overview" onClick={goAnchor('overview')} style={{ color: '#dbe3ef' }} className="link-underline">{t('nav.overview')}</a></li>
              <li><a href="#why" onClick={goAnchor('why')} style={{ color: '#dbe3ef' }} className="link-underline">{t('nav.why')}</a></li>
              <li><a href="#process" onClick={goAnchor('process')} style={{ color: '#dbe3ef' }} className="link-underline">{t('nav.process')}</a></li>
              <li><a href="#transparency" onClick={goAnchor('transparency')} style={{ color: '#dbe3ef' }} className="link-underline">{t('nav.transparency')}</a></li>
              <li><a href="#contact" onClick={goAnchor('contact')} style={{ color: '#dbe3ef' }} className="link-underline">{t('nav.contact')}</a></li>
            </ul>
          </div>

          <div>
            <h4 style={{ color: 'white', fontSize: 12, letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 16, fontWeight: 700 }}>
              {t('footer.legalTitle')}
            </h4>
            <ul className="flex flex-col gap-2.5" style={{ fontSize: 14 }}>
              <li><Link to={`/${lang}/privacy`} style={{ color: '#dbe3ef' }} className="link-underline">{t('nav.privacy')}</Link></li>
              <li><Link to={`/${lang}/cookies`} style={{ color: '#dbe3ef' }} className="link-underline">{t('nav.cookies')}</Link></li>
              <li><Link to={`/${lang}/terms`} style={{ color: '#dbe3ef' }} className="link-underline">{t('nav.terms')}</Link></li>
              <li><a href="#cookie-prefs" onClick={openCookiePrefs} style={{ color: '#dbe3ef' }} className="link-underline">{t('cookies.manage')}</a></li>
            </ul>
          </div>

          <div>
            <h4 style={{ color: 'white', fontSize: 12, letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 16, fontWeight: 700 }}>
              {t('footer.companyTitle')}
            </h4>
            <ul className="flex flex-col gap-2" style={{ fontSize: 13.5, color: '#b7c4d8', lineHeight: 1.6 }}>
              <li>{t('footer.companyName')}</li>
              <li>{t('footer.registration')}</li>
              <li>{t('footer.cuit')}</li>
              <li>{t('footer.license')}</li>
              <li>{t('footer.jurisdiction')}</li>
              <li>{t('footer.incorporated')}</li>
              <li>{t('footer.address')}</li>
              <li style={{ marginTop: 6 }}>
                {t('footer.emailLabel')}: <a href="mailto:contacto@geodatosarg.com" style={{ color: 'white' }} className="link-underline">contacto@geodatosarg.com</a>
              </li>
              <li>{t('footer.phoneLabel')}: <a href="tel:+541150328470" style={{ color: 'white' }} className="link-underline">+54 11 5032-8470</a></li>
            </ul>
          </div>
        </div>

        <div style={{ height: 1, background: '#1e3b6a', margin: '48px 0 24px' }} />

        <div className="flex flex-col md:flex-row md:items-start gap-4 md:justify-between" style={{ fontSize: 12.5, color: '#8ea1c1' }}>
          <p style={{ maxWidth: 780, lineHeight: 1.7 }}>{t('footer.disclaimer')}</p>
          <p>{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
}
